import * as React from 'react';
import * as ProductEditStore from '@/redux/pages/product-edit';

import ActionSheet from '@/pages/components/common/ui/actionsheet/index';
import store from '@/redux/index';

import { types } from '@/redux/ui/actionsheet';
import { connect } from 'react-redux';
import config from '@/server/config';
import request from '@/server/request';

const Toast = require('react-toast-mobile');

class ProductActivity extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {

        }
    }

    public componentDidMount() {
    	if (!this.props.munufacturer_id) {
    		this.getCompanyName();
    	}
    }

    public render() {
        const state = this.state;
        const props = this.props;
        return (
            <section className="expert-edit ylk-edit">
                <section className="ylk-edit-block">
                    <div className="ylk-edit-wrapper">
                        <div className="expert-edititem">
                            <div className="expert-editlabel">
                                <span>*</span>
                            	产品中文名称
                        	</div>
                            <div className="expert-editgroup">
                                <input type="text" placeholder="请填写" onChange={() => this.inputAction('productName')} value={props.productName} />
                            </div>
                        </div>
                        <div className="expert-edititem" onClick={() => this.navigateToManufacturer('/u/product/selectmanufacturer?type=1')}>
                            <div className="expert-editlabel">
                                <span>*</span>
                                供应商
                            </div>
                            <div className="expert-editgroup">
                                <p className={props.munufacturer_name ? 'active' : ''}>{props.munufacturer_name || '请选择'}</p>
                                <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                            </div>
                        </div>
                        <div className="expert-edititem" onClick={() => this.uploadFile('tds')}>
                            <div className="expert-editlabel">
                            	<span>*</span>
                                产品TDS
                        	</div>
	                        <div className="expert-editgroup">
	                            <p className={props.tds ? 'active' : ''}>{props.tds ? '已上传' : '请上传'}</p>
	                            {
	                                state.source !== '4' ?
	                                    <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" /> : null
	                            }
	                        </div>
	                    </div>
	                    <div className="expert-edititem" onClick={() => this.uploadFile('msds')}>
	                        <div className="expert-editlabel">
	                            产品MSDS
	                        </div>
	                        <div className="expert-editgroup">
	                            <p className={props.msds ? 'active' : ''}>{props.msds ? '已上传' : '请上传'}</p>
	                            {
	                                state.source !== '4' ?
	                                    <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" /> : null
	                            }
	                        </div>
	                    </div>
	                </div>
                </section>
                
                <div className="expert-editbottom">
                    <button className="btn-submit" onClick={() => this.nextAction()}>发布</button>
                </div>
                <ActionSheet project="ylk"/>
            </section>
        )
    }

    // 获取供应商名称简称id
    private async getCompanyName() {
        const r = await request({
            method: "get",
            url: `${config.WAPAPI}safety/account/get`,
            data: {
                queryType: 1,
            }
        });

        if (r.code === 1) {
            if (r.obj && r.obj.companyInfo) {
                store.dispatch({
                    type: ProductEditStore.types.CONCAT,
                    concatData: {
                        logo: r.obj.companyInfo.logoUrl || '',
                        munufacturer_id: r.obj.companyInfo.id || '',
                        munufacturer_name: r.obj.companyInfo.company || '',
                        munufacturer_abbreviation: r.obj.companyInfo.companyNickName || ''
                    }
                });
            }

        }
    }

    /**
     * 上传
     * @param type 
     */
    private uploadFile(type: string) {
        store.dispatch({
            type: types.ACTIONSHEET_SHOW,
            data: {
                type: 'file',
                formData: {}
            },
            callback(r: any) {
                if (r.flag === 1) {
                    store.dispatch({
                        type: ProductEditStore.types.INPUT,
                        data: {
                            key: type,
                            value: r.data.url
                        }
                    });
                } else {
                    Toast.T.notify(r.msg);
                }
            }
        });
    }
    // 发布
    private async submitAction() {

        const props = this.props;

        let data = `PRODUCT_NAME=${props.productName}&MUNUFACTURER_NAME=${props.munufacturer_name}&MUNUFACTURER_ID=${props.munufacturer_id}&TDS=${props.tds}&MSDS=${props.msds}`

        const r = await request({
            url: config.ULKAPI + 'api/web/index.php?r=second/product/product-pdf',
            method: 'post',
            data,
        });

        if (r.error_code === 0) {
            Toast.T.notify('发布成功');
            store.dispatch({
                type: ProductEditStore.types.CLEAR
            });
        } else {
            Toast.T.notify(r.msg);
        }

    }

    /**
     * 输入处理
     * @param modelName {string} 模块名称
     */
    private inputAction(modelName: string) {

        store.dispatch({
            type: ProductEditStore.types.INPUT,
            data: {
                key: modelName,
                value: (event as any).target.value
            }
        });

    }

    // 下一步
    private nextAction() {
        const props = this.props;

        if (props.productName === '') {
            return Toast.T.notify('请填写产品中文名称');
        } else if (!/[\u4e00-\u9fa5]/img.test(props.productName)) {
            return Toast.T.notify('产品中文名称必须包含中文');
        } else if (props.productName.length > 200) {
            return Toast.T.notify('产品中文名称最多200个字');
        } 

        if (props.munufacturer_id === '') {
            return Toast.T.notify('请选择供应商');
        }

        if (props.tds === '') {
        	return Toast.T.notify('请上传TDS文件');
        }

         this.submitAction();
    }

    /**
     * 跳转
     * @param path {string} 路径
     */
    private navigateToManufacturer(path: string) {
        this.props.history.push(path);
    }
}

const mapStateToProps = (state: any): ProductEditStore.IProductEditState => {
    return {
        ...state.productEditReducers
    }
}

export default connect(mapStateToProps)(ProductActivity);